var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerHalborn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 21,
    viewBox: "0 0 212 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1952_1687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1952_1687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 212,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212 0H0V21H212V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1952_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.601 0H184.432L179.6 21H184.769L189.601 0Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.001 0H206.831L202 21H207.169L212.001 0Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.769 0L202 21H196.83L189.6 0H194.769Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9123 16.0257L70.5992 0H65.4302L60.5989 21H88.1679L89.3119 16.0257H66.9123Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1807 0L90.3491 21H109.579C114.184 21 118.745 17.4068 119.764 12.9748L115.739 8.00055H120.908C121.925 3.58209 119.027 0.00041079 114.435 0.00041079L95.1807 0ZM110.75 16.0254H96.6629L97.3644 12.9744H114.596L114.59 12.9994C114.205 14.6705 112.486 16.0254 110.75 16.0254ZM115.74 8.00013H98.509L99.2051 4.97425H113.292C115.029 4.97425 116.124 6.32904 115.74 8.00013Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.417 21L179.263 12.9748L175.239 8.00055H180.408C181.424 3.58209 178.526 0 173.935 0H154.679L149.848 20.9996H155.017L156.864 12.9744H174.094L172.248 20.9996L177.417 21ZM175.239 8.00055H158.007L158.704 4.97466H172.79C174.527 4.97466 175.622 6.32945 175.239 8.00055Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.929 0L120.098 21H147.667L152.498 0H124.929ZM143.641 16.0257H126.411L128.953 4.97466H146.184L143.641 16.0257Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9161 0H43.1985L29.7521 21H34.9211L48.9161 0H54.6331L58.4173 21H53.2483L48.9161 0Z",
    fill: "#C5FF01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.231 0L25.3878 8.01287H8.15708L10.0003 0H4.83133L0 21H5.16941L8.15708 8.01287L12.1816 12.9875H24.2433L22.3997 21H27.569L32.4 0H27.231Z",
    fill: "#C5FF01"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1952_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerHalborn);
export default __webpack_public_path__ + "static/media/partner-halborn.6e65d539473123afb1ac8cbadcdce679.svg";
export { ForwardRef as ReactComponent };